import { Store, createStore, applyMiddleware, Middleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'app/reducers';
import { routerMiddleware } from 'react-router-redux';
import invariant from 'redux-immutable-state-invariant';

export const configureStore = (initialState: any = {}, history) => {
  const middleware = [thunk, invariant()];

  // Router Middleware
  const router = routerMiddleware(history);
  middleware.push(router);

  const enhancer = applyMiddleware(...middleware);

  return createStore(rootReducer, initialState, enhancer);
};
